import React from 'react';
import SiteInfoButton from '@ctsu/site-i-button';
import { useUsername } from 'helpers';
import { getToken } from '@ctsu/loader';
import { ATCONSTANTS as ATC } from 'appconstants';
import { CanUserViewIbutton } from 'appconstants/Permission';
import { RenderElement } from 'components/RenderHelpers';

function SiteIButton({ siteCtepId }) {
  const username = useUsername();
  const canViewIButton = CanUserViewIbutton();
  return !siteCtepId ? null : (
    <RenderElement access={canViewIButton}>
      <SiteInfoButton
        id={siteCtepId}
        color="#13808F"
        dataId={`${ATC.CAPID}${siteCtepId}_SITE_I_BUTTON_${ATC.LINK}`}
        getToken={getToken}
        appUrl={process.env.REACT_APP_ORIGIN}
        smallSize
        userName={username}
      />
    </RenderElement>
  );
}

export default SiteIButton;
